import React, { useEffect, useState } from "react";
import TextField from "calcite-react/TextField";

import "./SaveNShare.scss";
import Button from "calcite-react/Button/Button";
import { environment } from "../../../constants/environment";

function SaveNShare() {
  const [url, setURL] = useState("");

  const handleCopyToClipboard = () => {
    const copyText = document.querySelector("#saveURL");
    copyText.select();
    document.execCommand("copy");
  };

  useEffect(() => {
    const fetchShortURL = async () => {
      const requestHeaders = {
        "Content-Type": "application/json",
        apikey: environment.rebrandlyAPIKey,
      };

      const linkRequest = {
        destination: window.location.href,
      };

      let data;
      try {
        const response = await fetch(`https://api.rebrandly.com/v1/links`, {
          method: "POST",
          headers: requestHeaders,
          body: JSON.stringify(linkRequest),
        });
        data = await response.json();
        if (data.shortUrl) {
          setURL(data.shortUrl);
        } else {
          setURL(window.location.href);
        }
      } catch (e) {
        setURL(window.location.href);
      }
    };

    fetchShortURL();
  }, [setURL]);

  return (
    <div className="saveNShare">
      <h2>Permalink</h2>
      <TextField
        id="saveURL"
        fullWidth={true}
        value={url}
        rightAdornment={<Button onClick={handleCopyToClipboard}>Copy</Button>}
      />
    </div>
  );
}

export default SaveNShare;
